<template>
    <v-card class="settings-card">
        <div class="card-section-header px-6 py-4">
            <div class="d-flex align-center">
                <v-icon class="mr-2" color="white" size="18">mdi-note-text-outline</v-icon>
                <span class="card-section-title">Notes</span>
            </div>
            <div class="card-section-subtitle">Shared with the event once this lead books</div>
        </div>
        <v-card-text>
            <div class="notes-container mb-4">
                <div v-if="!loading && notes.length === 0" class="no-notes">No notes yet</div>
                <div v-for="note in notes" :key="note.id" class="note-item">
                    <div class="note-header">
                        <div class="note-meta">
                            <label class="note-date">{{ $date(note.created_at).format('DD/MM/YYYY HH:mm') }}</label>
                            <label v-if="note.creator" class="note-author"> • {{ note.creator.name }}</label>
                            <label class="note-origin"> • {{ noteOrigin(note) }}</label>
                        </div>
                        <v-btn icon x-small @click="deleteNote(note)">
                            <v-icon x-small color="error">mdi-delete-outline</v-icon>
                        </v-btn>
                    </div>
                    <div class="note-content">{{ note.note_content }}</div>
                </div>
            </div>
            <v-textarea v-model="new_note_content" outlined dense hide-details auto-grow
                placeholder="Add a note..." rows="3"></v-textarea>
            <div class="d-flex justify-end mt-3">
                <v-btn small dark color="#3988AA" :disabled="!new_note_content" :loading="saving" @click="createNote()">
                    Add Note
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { noteOrigin } from '@/utils/noteOrigin'

export default {
    props: {
        lead_id: { type: Number, required: true },
    },
    data: () => ({
        notes: [],
        loading: false,
        saving: false,
        new_note_content: null,
    }),
    mounted() {
        this.fetchNotes()
    },
    watch: {
        lead_id() {
            this.fetchNotes()
        },
    },
    methods: {
        noteOrigin,
        async fetchNotes() {
            this.loading = true
            try {
                const result = (await this.$axios.get(`admin/events/get_lead_notes/${this.lead_id}`)).data
                if (result.response == true) {
                    this.notes = result.data
                }
            } finally {
                this.loading = false
            }
        },
        async createNote() {
            if (!this.new_note_content) return
            this.saving = true
            try {
                const result = (await this.$axios.post('admin/events/create_event_note', {
                    lead_id: this.lead_id,
                    note_content: this.new_note_content,
                })).data
                if (result.response == true) {
                    this.$toast.success('Note added')
                    this.new_note_content = null
                    this.notes.unshift(result.data)
                } else {
                    this.$toast.error('Failed to add note')
                }
            } finally {
                this.saving = false
            }
        },
        async deleteNote(note) {
            const result = (await this.$axios.delete(`admin/events/delete_event_note/${note.id}`)).data
            if (result.response == true) {
                this.$toast.success('Note deleted')
                this.notes = this.notes.filter(n => n.id !== note.id)
            } else {
                this.$toast.error('Failed to delete note')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.settings-card {
    border-radius: 10px !important;
    border: 1px solid #E9E9E9 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
    overflow: hidden;
}

.card-section-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.card-section-title {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    color: white;
}

.card-section-subtitle {
    font-family: Manrope;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 2px;
}

.notes-container {
    max-height: 300px;
    overflow-y: auto;
    padding: 4px;
}

.no-notes {
    text-align: center;
    padding: 24px;
    color: #999;
    font-size: 13px;
    font-style: italic;
}

.note-item {
    background-color: white;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 8px;
}

.note-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.note-meta {
    display: flex;
    gap: 2px;
}

.note-date {
    font-size: 10px;
    color: #999;
    font-weight: 500;
}

.note-author {
    font-size: 11px;
    color: #3498DB;
    font-weight: 600;
}

.note-origin {
    font-size: 11px;
    color: #7F8C8D;
}

.note-content {
    font-size: 13px;
    color: #2C3E50;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
}
</style>
